import React, { useEffect, useState } from "react";

export default function Timer(props) {
  const [seconds, setSeconds] = useState(Math.floor((props.startTimeInMilliseconds / 1000) % 60));
  const [minutes, setMinutes] = useState(Math.floor((props.startTimeInMilliseconds / (1000 * 60)) % 60));
  const [hours, setHours] = useState(Math.floor((props.startTimeInMilliseconds / (1000 * 60 * 60)) % 24));
  
  const increaseSeconds = () => setSeconds((prev) => prev + 1);
  const increaseMinutes = () => setMinutes((prev) => prev + 1);
  const increaseHours = () => setHours((prev) => prev + 1);

  let timer = undefined;

  useEffect(() => {
    timer = setInterval(() => {
      increaseSeconds()

      if(seconds === 59){
        increaseMinutes();
        setSeconds(0);
      }
      
      if(minutes === 59){
        increaseHours();
        setMinutes(0);
      }
    }, 1000);

    return () => clearInterval(timer);
  });

  function renderTime() {
    if (hours > 0) {
      return `${formatUnit(hours, 'час')} ${formatUnit(minutes, 'минут')} назад`;
    } else {
      if (minutes > 0) {
        return `${formatUnit(minutes, 'минут')} назад`;
      } else {
        return 'только что';
      }
    }
  }

  function formatUnit(time, unit) {
    const hourForms = ['час', 'часа', 'часов'];
    const minuteForms = ['минуту', 'минуты', 'минут'];

    let formIndex;

    if (unit === 'час') {
      if (time === 1) {
        formIndex = 0; 
      } else if (time >= 2 && time <= 4) {
        formIndex = 1; 
      } else if ((time >= 5 && time <= 20) || time === 0) {
        formIndex = 2; 
      } else if (time % 10 === 1) {
        formIndex = 0; 
      } else if (time % 10 >= 2 && time % 10 <= 4) {
        formIndex = 1; 
      }
      return `${time} ${hourForms[formIndex]}`;
    } else if (unit === 'минут') {
      if (time === 1) {
        formIndex = 0; 
      } else if (time >= 2 && time <= 4) {
        formIndex = 1; 
      } else if ((time >= 5 && time <= 20) || time === 0) {
        formIndex = 2; 
      } else if (time % 10 === 1) {
        formIndex = 0; 
      } else if (time % 10 >= 2 && time % 10 <= 4) {
        formIndex = 1; 
      } else if (time % 10 >= 5 && time % 10 <= 9 || time % 10 === 0) {
        formIndex = 2; 
      }
      return `${time} ${minuteForms[formIndex]}`;
    }
  }

  return <div>{renderTime()}</div>;
}